module.exports = __webpack_public_path__ + "img/return.ef0885fa.svg";